import React from 'react';
import Splash from './splash';

export default function Landingpage() {
  return (
    <div id="main">
      <Splash />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/landingpage.js